import { useMemo } from "react";

import { EntityId } from "@reduxjs/toolkit";

import { Alert, Table, TableBody, TableCell, TableRow } from "@mui/material";

import { useAppSelector } from "app/hooks";
import { RootState } from "app/store";
import { playbackDebugSelectors } from "./store/selectors.debug";

export interface PlaybackDeviceDebugStatisticsProps {
    deviceId: EntityId;
}

export function PlaybackDeviceDebugStatistics(
    props: PlaybackDeviceDebugStatisticsProps,
) {
    const selectRecordingsWithPlaybackStateByDeviceId = useMemo(
        () =>
            playbackDebugSelectors.selectRecordingsWithPlaybackStateByDeviceIdFactory(),
        [],
    );

    const recordingsWithPlaybackStateByDeviceId = useAppSelector(
        (state: RootState) =>
            selectRecordingsWithPlaybackStateByDeviceId(state, props.deviceId),
    );

    return (
        <Alert severity="info">
            <Table size="small">
                <TableBody>
                    <TableRow>
                        <TableCell>Recordings</TableCell>
                        <TableCell>
                            {recordingsWithPlaybackStateByDeviceId.length}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>In playback window</TableCell>
                        <TableCell>
                            {
                                recordingsWithPlaybackStateByDeviceId.filter(
                                    (x) => x.inPlaybackWindow,
                                ).length
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>In buffer window</TableCell>
                        <TableCell>
                            {
                                recordingsWithPlaybackStateByDeviceId.filter(
                                    (x) => x.inBufferWindow,
                                ).length
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Outside buffer/playback window</TableCell>
                        <TableCell>
                            {
                                recordingsWithPlaybackStateByDeviceId.filter(
                                    (x) =>
                                        !x.inBufferWindow &&
                                        !x.inPlaybackWindow,
                                ).length
                            }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Alert>
    );
}
